import { type ReactNode } from "react";

interface FeatureCardProps {
  className?: string;
  /** 32×32 icon element */
  icon: ReactNode;
  /** Feature title */
  title: string;
  /** Feature description */
  description: string;
}

export function FeatureCard({ className = "", icon, title, description }: FeatureCardProps) {
  return (
    <div
      className={`bg-white flex gap-[16px] h-[176px] max-desktop:h-auto max-desktop:min-h-[176px] items-start max-desktop:items-center max-tablet:items-start justify-center p-[20px] rounded-[24px] w-[405px] max-w-full max-desktop:flex-col max-tablet:flex-row max-desktop:text-center max-tablet:text-left hover:shadow-[0px_0px_10px_rgba(0,0,0,0.07)] transition-shadow ${className}`}
    >
      <div className="size-[32px] shrink-0 relative overflow-hidden">
        {icon}
      </div>
      <div className="flex flex-1 flex-col gap-[8px] items-start max-desktop:items-center max-tablet:items-start min-w-0 w-full">
        <span
          className="[font-family:var(--font-commissioner)] font-medium not-italic text-[24px] leading-[32px] text-[rgba(0,0,0,0.9)] tracking-[-0.48px] whitespace-nowrap"
          style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
        >
          {title}
        </span>
        <p
          className="[font-family:var(--font-commissioner)] font-medium not-italic text-[18px] leading-[24px] text-[rgba(0,0,0,0.4)] tracking-[-0.36px] min-w-0 break-words"
          style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
        >
          {description}
        </p>
      </div>
    </div>
  );
}
